import * as React from "react";
import { Heading, Stack, StackProps, Text } from "@chakra-ui/react";

interface StatProps extends StackProps {
  title: string;
  number: string;
  isFirstLink?: boolean;
}

export const Stat = (props: StatProps) => {
  const { title, number, isFirstLink, ...stackProps } = props;

  return (
    <Stack
      spacing={1}
      textAlign="left"
      {...stackProps}
      pl={{ base: "6", md: "10" }}
      mr={6}
      borderLeft={{
        md: `${isFirstLink ? "6px solid #B2BB42" : "none"}`,
        base: "6px solid #B2BB42",
      }}
    >
      <Heading fontSize={{ base: "4xl", md: "5xl" }}>{number}</Heading>
      <Text
        fontSize="md"
        textTransform="uppercase"
        fontWeight={700}
        color="#817C25"
        pb={{ base: "6", md: "auto" }}
      >
        {title}
      </Text>
    </Stack>
  );
};
